import { render, staticRenderFns } from "./TableExpenses.vue?vue&type=template&id=00ffceb8"
import script from "./TableExpenses.vue?vue&type=script&lang=js"
export * from "./TableExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports